import FeatureDetailsTexts from "@/v2-backoffice-client/feature/details/FeatureDetailsTexts"
import NavLayerViewDetailsHotfixTexts from "@/v2-backoffice-client/navlayer/view/NavLayerViewDetailsHotfixTexts"
import { IS_CATALOG_AUTHORING_ENABLED } from "@/v2-backoffice-client/feature/feature.constants"
import type { NavLayerFragment } from "@/v2-backoffice-client/navlayer/__types__/navlayer.fragment"

export type NavLayerViewDetailsProps = {
  navLayer: NavLayerFragment
}

/**
 * Details form of the nav layer sheet. A nav layer has no presentation of
 * its own — it is geometry the map selects against, never something a user
 * picks from a list — so its name and description are the whole form.
 */
function NavLayerViewDetails(props: NavLayerViewDetailsProps) {
  const { navLayer } = props

  return (
    <div className="flex flex-col gap-6 pt-2">
      {IS_CATALOG_AUTHORING_ENABLED ? (
        <FeatureDetailsTexts
          featureCode={navLayer.FeatureCode}
          subject="nav layer"
          featureCodeLabel="NavLayers"
        />
      ) : (
        <NavLayerViewDetailsHotfixTexts navLayer={navLayer} />
      )}
    </div>
  )
}

export default NavLayerViewDetails
